var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b2b-button',{staticClass:"mt--3",attrs:{"flat":"","dense":""},on:{"click":_vm.$_onClick}},[_c('download-cloud-icon',{staticClass:"mr--3"}),_vm._v(" "+_vm._s(_vm.$t('install-app'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }